// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FileUploadPresentationPropsDefault from "@insite/mobius/FileUpload/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import Remove from "@mcmc/XDL/Icons/Remove";
import Upload from "@mcmc/XDL/Icons/Upload";
import { xBaseTheme } from "@mcmc/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        iconProps: {
            src: Upload,
            color: "secondary",
        },
        clearIconProps: {
            src: Remove,
            color: "secondary",
        },
        transitionLength: "short",
        buttonProps: {
            css: css`
                display: inline-flex;
            `,
        },
    },
} as xBaseTheme["fileUpload"];
